export const shouldDisplayCadastreValue = value => {
    if (value == null) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    return !!value || value === 0;
};

export const isAtLeastOneCadastreFieldValidForDisplay = values => {
    if (values == null || !Array.isArray(values)) return false;
    return values.filter(v => shouldDisplayCadastreValue(v)).length > 0;
};
